import {MultipleLineError} from "@dvrt/graphql-widgets";

export default MultipleLineError;
